import { render, staticRenderFns } from "./rule-group-datatable.component.vue?vue&type=template&id=9b9602d4&scoped=true&"
import script from "./rule-group-datatable.component.vue?vue&type=script&lang=ts&"
export * from "./rule-group-datatable.component.vue?vue&type=script&lang=ts&"
import style0 from "./rule-group-datatable.component.vue?vue&type=style&index=0&id=9b9602d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9602d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VExpandTransition,VIcon,VSpacer})
